import React from "react"
import { Link } from "gatsby"

import { setLogoImgFallbackOnError } from '../../utils/logoPlaceholder'

import CommunityStarRating from "./starrating"

import { sortCommunities } from '../../utils/communities'

const hasDisplayableRating = (c) =>
  c.reviewCount !== null &&
  c.reviewCount !== undefined &&
  c.reviewCount !== '0' &&
  c.reviewAvg !== null &&
  c.reviewAvg !== undefined

const SimilarCommunities = ({
  communities,
  hideTopPicks,
  hideRatings,
  defaultCount = 4,
  showAll = false,
  minimalListView = false,
}) => {
  const countToShow = showAll ? communities.length : defaultCount

  const communitiesToShow = sortCommunities('Ratings', communities)
    .sort((a, b) => (a.promoted < b.promoted) ? 1 : ((b.promoted < a.promoted) ? -1 : 0))
    .sort((a, b) => (a.gold < b.gold) ? 1 : ((b.gold < a.gold) ? -1 : 0))
    .slice(0, countToShow)

  const showLogo = (c) => !minimalListView && c.gold && c.logo && !hideTopPicks

  return (
    <React.Fragment>
      <ul className={minimalListView ? 'space-y-0' : 'divide-y divide-gray-200'}>
        {communitiesToShow.map((c) => (
          <li key={c.slug}>
            <Link
              to={`/communities/${c.slug}/`}
              className={
                minimalListView
                  ? 'block rounded py-1 hover:bg-gray-50'
                  : 'block hover:bg-gray-50 p-2 py-3 flex'
              }
            >
              {showLogo(c) ? (
                <img className="flex-shrink-0 h-20 w-20 mr-4 object-contain rounded-md object-left sm:object-center" src={c.logo} alt={`${c.name} logo`} width="70" height="42" loading="lazy"
                  onError={setLogoImgFallbackOnError}
                />
              ) : ''}

              <div>
                {minimalListView ? (
                  <React.Fragment>
                    <div className="flex items-start justify-between gap-2 leading-tight">
                      <p className="min-w-0 flex-1 truncate text-sm font-medium text-gray-700">{c.name}</p>
                      {!hideRatings && hasDisplayableRating(c) ? (
                        <div className="flex shrink-0 items-center">
                          <CommunityStarRating community={c} compact />
                        </div>
                      ) : null}
                    </div>
                    {c.description ? (
                      <p className="mt-0 truncate text-left text-xs text-gray-500 whitespace-nowrap">
                        {c.description}
                      </p>
                    ) : null}
                  </React.Fragment>
                ) : (
                  <React.Fragment>
                    <div className="text-sm items-center">
                      <p className="font-medium text-gray-700 truncate">{c.name}</p>

                      {false && !hideTopPicks && c.promoted ? (
                        <div className="ml-auto py-0.5 px-1 mb-0.5 bg-yellow-400 rounded-sm text-xs text-white flex items-center">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
                          </svg>
                          <div>Featured</div>
                        </div>
                      ) : !hideRatings && hasDisplayableRating(c) ? (
                        <div className="mt-0 flex items-center text-xs">
                          <CommunityStarRating community={c} compact />
                        </div>
                      ) : ''}
                    </div>
                    {c.description ? (
                      <div className={`mt-1 text-xs text-gray-500 ${c.gold && !hideTopPicks ? 'line-clamp-3' : 'line-clamp-2'}`}>
                        {c.description}
                      </div>
                    ) : ''}
                  </React.Fragment>
                )}
              </div>
            </Link>
          </li>
        ))}
      </ul>
    </React.Fragment>
  )

}


export default SimilarCommunities